import React from 'react'
import {
	AreaChart,
	Area,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	ResponsiveContainer,
} from 'recharts'
import './PortfolioGrowthChart.css'

const data = [
	{ date: 'Jan 1', value: 20000 },
	{ date: 'Jan 15', value: 20500 },
	{ date: 'Feb 1', value: 21000 },
	{ date: 'Feb 15', value: 21600 },
	{ date: 'Mar 1', value: 22200 },
	{ date: 'Mar 15', value: 22800 },
	{ date: 'Apr 1', value: 23400 },
	{ date: 'Apr 15', value: 24000 },
	{ date: 'May 1', value: 24600 },
]

const PortfolioGrowthChart = () => {
	return (
		<div className="chart-card">
			<h3>Portfolio Growth</h3>
			<ResponsiveContainer width="100%" height={300}>
				<AreaChart
					data={data}
					margin={{ top: 20, right: 30, left: 0, bottom: 0 }}
				>
					<defs>
						<linearGradient
							id="goldGradient"
							x1="0"
							y1="0"
							x2="0"
							y2="1"
						>
							<stop
								offset="5%"
								stopColor="#f5c542"
								stopOpacity={0.6}
							/>
							<stop
								offset="95%"
								stopColor="#f5c542"
								stopOpacity={0}
							/>
						</linearGradient>
					</defs>
					<CartesianGrid strokeDasharray="4 4" stroke="#333" />
					<XAxis dataKey="date" stroke="#ccc" />
					<YAxis
						stroke="#ccc"
						tickFormatter={(v) => `$${(v / 1000).toFixed(0)}k`}
					/>
					<Tooltip
						contentStyle={{
							background: '#1a1a1a',
							border: 'none',
							borderRadius: '8px',
						}}
						labelStyle={{ color: '#fff' }}
						formatter={(value) => [
							`$${value.toLocaleString()}`,
							'Value',
						]}
					/>
					<Area
						type="monotone"
						dataKey="value"
						stroke="#f5c542"
						fillOpacity={1}
						fill="url(#goldGradient)"
						strokeWidth={2}
					/>
				</AreaChart>
			</ResponsiveContainer>
		</div>
	)
}

export default PortfolioGrowthChart
